import {required} from "vuelidate/lib/validators";

export class Species {
    constructor(initObjectParams) {
        this.id = null;
        this.name = null;
    }

    static get modelName() {
        return 'Species'
    }

    static get validations() {
        return {
            name: { required },
        }
    }

    static get validationFieldLabels() {
        return {
            name: 'Название',
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return 'Вид'
    }

    static get newLabel() {
        return 'Новый вид'
    }

    objectLabel() {
        return `${this.name}`
    }

    applyData(data) {
        this.id = data['id'];
        this.name = data['name'];
    }

}